export const maxHeightToSetOverflowInApp = 860
